function hasClass(element, className) {
    return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
}


window.onload = function() {
  $('a[href="#search"]').click(function(){
	  $('html,body').animate({ scrollTop: 0 }, 'slow');
    setTimeout(function(){
      $('#ls-button-search').click()
      $('#ls-form .ls-input').focus()
    }, 500)

  })
}